import { MplusServiceType, MplusStatus } from 'redux/services/mplus/types'

export const MPLUS_STATUS_TEXT: Record<MplusStatus, string> = {
  [MplusStatus.waiting]: 'В очереди',
  [MplusStatus.ready]: 'Подключен',
  [MplusStatus.error]: 'Ошибка',
}

export const MPLUS_SERVICE_TYPE_TEXT: Record<MplusServiceType, string> = {
  [MplusServiceType.mplus]: 'М+',
  [MplusServiceType.murabaha]: 'Мурабаха',
  [MplusServiceType.adal]: 'Адал',
}
